import { trfSigningPath } from '@/features/docusign/signingPath'
import { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'

/**
 * Bare ``/sign``, kept only so links from before the order id moved into the
 * path still land somewhere.
 *
 * ``?orderId=`` becomes ``/sign/{orderId}``. Anything else — a stale reminder
 * link's ``?t=`` above all — names no order we can sign, so the visitor goes to
 * the orders list, whose guard sends a signed-out visitor through login first.
 * Nothing here reads the token: it is dropped with the rest of the query.
 */
export function SignLegacyEntry() {
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('orderId')?.trim() ?? ''

  // A full load rather than a route change, so the orders list gets its own
  // headers instead of the ceremony's; ``replace`` so the stale URL leaves
  // history.
  useEffect(() => {
    if (!orderId) window.location.replace('/orders')
  }, [orderId])

  if (orderId) return <Navigate to={trfSigningPath(orderId)} replace />
  return null
}

export default SignLegacyEntry
